module.exports = __webpack_public_path__ + "media/images/design/images/btn_crowd-32ad0ed45e39d1a00535edc797bfff3c.png";